// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./revicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./revicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./revicons.eot", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "revicons";
  fallback: fallback;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("ttf");
}
.react-multi-carousel-list {
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.react-multi-carousel-track {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  position: relative;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  will-change: transform, transition;
}

.react-multiple-carousel__arrow {
  position: absolute;
  outline: 0;
  transition: all 0.5s;
  border-radius: 35px;
  z-index: 1000;
  border: 0;
  background: rgba(0, 0, 0, 0.5);
  min-width: 43px;
  min-height: 43px;
  opacity: 1;
  cursor: pointer;
}

.react-multiple-carousel__arrow:hover {
  background: rgba(0, 0, 0, 0.8);
}

.react-multiple-carousel__arrow::before {
  font-size: 20px;
  color: #fff;
  display: block;
  font-family: revicons;
  text-align: center;
  z-index: 2;
  position: relative;
}

.react-multiple-carousel__arrow:disabled {
  cursor: default;
  background: rgba(0, 0, 0, 0.5);
}

.react-multiple-carousel__arrow--left {
  left: calc(4% + 1px);
}

.react-multiple-carousel__arrow--left::before {
  content: "\\e824";
}

.react-multiple-carousel__arrow--right {
  right: calc(4% + 1px);
}

.react-multiple-carousel__arrow--right::before {
  content: "\\e825";
}

.react-multi-carousel-dot-list {
  position: absolute;
  bottom: 0;
  display: flex;
  left: 0;
  right: 0;
  justify-content: center;
  margin: auto;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
}

.react-multi-carousel-dot button {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 1;
  padding: 5px 5px 5px 5px;
  box-shadow: none;
  transition: background 0.5s;
  border-width: 2px;
  border-style: solid;
  border-color: grey;
  padding: 0;
  margin: 0;
  margin-right: 6px;
  outline: 0;
  cursor: pointer;
}

.react-multi-carousel-dot button:hover:active {
  background: #080808;
}

.react-multi-carousel-dot--active button {
  background: #080808;
}

.react-multi-carousel-item {
  transform-style: preserve-3d;
  backface-visibility: hidden;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .react-multi-carousel-item {
    flex-shrink: 0 !important;
  }
  .react-multi-carousel-track {
    overflow: visible !important;
  }
}
[dir=rtl].react-multi-carousel-list {
  direction: rtl;
}

.rtl.react-multiple-carousel__arrow--right {
  right: auto;
  left: calc(4% + 1px);
}

.rtl.react-multiple-carousel__arrow--right::before {
  content: "\\e824";
}

.rtl.react-multiple-carousel__arrow--left {
  left: auto;
  right: calc(4% + 1px);
}

.rtl.react-multiple-carousel__arrow--left::before {
  content: "\\e825";
}`, "",{"version":3,"sources":["webpack://./node_modules/react-multi-carousel/lib/styles.css"],"names":[],"mappings":"AAAA;EAAW,uBAAA;EAAuB,kBAAA;EAAkB,yKAAA;AAIpD;AAJsK;EAA2B,aAAA;EAAa,mBAAA;EAAmB,gBAAA;EAAgB,kBAAA;AAUjP;;AAVmQ;EAA4B,gBAAA;EAAgB,UAAA;EAAU,SAAA;EAAS,aAAA;EAAa,mBAAA;EAAmB,kBAAA;EAAkB,4BAAA;EAA4B,2BAAA;EAA2B,kCAAA;AAsB3a;;AAtB4c;EAAgC,kBAAA;EAAkB,UAAA;EAAU,oBAAA;EAAmB,mBAAA;EAAmB,aAAA;EAAa,SAAA;EAAS,8BAAA;EAA2B,eAAA;EAAe,gBAAA;EAAgB,UAAA;EAAU,eAAA;AAoCxoB;;AApCupB;EAAsC,8BAAA;AAwC7rB;;AAxCwtB;EAAwC,eAAA;EAAe,WAAA;EAAW,cAAA;EAAc,qBAAA;EAAqB,kBAAA;EAAkB,UAAA;EAAU,kBAAA;AAkDz1B;;AAlD22B;EAAyC,eAAA;EAAe,8BAAA;AAuDn6B;;AAvD87B;EAAsC,oBAAA;AA2Dp+B;;AA3Dw/B;EAA8C,gBAAA;AA+DtiC;;AA/DsjC;EAAuC,qBAAA;AAmE7lC;;AAnEknC;EAA+C,gBAAA;AAuEjqC;;AAvEirC;EAA+B,kBAAA;EAAkB,SAAA;EAAS,aAAA;EAAa,OAAA;EAAO,QAAA;EAAQ,uBAAA;EAAuB,YAAA;EAAY,UAAA;EAAU,SAAA;EAAS,gBAAA;EAAgB,kBAAA;AAqF70C;;AArF+1C;EAAiC,qBAAA;EAAqB,WAAA;EAAW,YAAA;EAAY,kBAAA;EAAkB,UAAA;EAAU,wBAAA;EAAwB,gBAAA;EAAgB,2BAAA;EAA0B,iBAAA;EAAiB,mBAAA;EAAmB,kBAAA;EAAkB,UAAA;EAAU,SAAA;EAAS,iBAAA;EAAiB,UAAA;EAAU,eAAA;AAwG9mD;;AAxG6nD;EAA8C,mBAAA;AA4G3qD;;AA5G8rD;EAAyC,mBAAA;AAgHvuD;;AAhH0vD;EAA2B,4BAAA;EAA4B,2BAAA;AAqHjzD;;AArH40D;EAAmE;IAA2B,yBAAA;EA0Hx6D;EA1Hi8D;IAA4B,4BAAA;EA6H79D;AACF;AA9H4/D;EAAsC,cAAA;AAiIliE;;AAjIgjE;EAA2C,WAAA;EAAW,oBAAA;AAsItmE;;AAtI0nE;EAAmD,gBAAA;AA0I7qE;;AA1I6rE;EAA0C,UAAA;EAAU,qBAAA;AA+IjvE;;AA/IswE;EAAkD,gBAAA;AAmJxzE","sourcesContent":["@font-face{font-family:\"revicons\";fallback:fallback;src:url(\"./revicons.woff\") format('woff'),url(\"./revicons.ttf\") format('ttf'),url(\"./revicons.eot\") format('ttf')}.react-multi-carousel-list{display:flex;align-items:center;overflow:hidden;position:relative}.react-multi-carousel-track{list-style:none;padding:0;margin:0;display:flex;flex-direction:row;position:relative;transform-style:preserve-3d;backface-visibility:hidden;will-change:transform,transition}.react-multiple-carousel__arrow{position:absolute;outline:0;transition:all .5s;border-radius:35px;z-index:1000;border:0;background:rgba(0,0,0,0.5);min-width:43px;min-height:43px;opacity:1;cursor:pointer}.react-multiple-carousel__arrow:hover{background:rgba(0,0,0,0.8)}.react-multiple-carousel__arrow::before{font-size:20px;color:#fff;display:block;font-family:revicons;text-align:center;z-index:2;position:relative}.react-multiple-carousel__arrow:disabled{cursor:default;background:rgba(0,0,0,0.5)}.react-multiple-carousel__arrow--left{left:calc(4% + 1px)}.react-multiple-carousel__arrow--left::before{content:\"\\e824\"}.react-multiple-carousel__arrow--right{right:calc(4% + 1px)}.react-multiple-carousel__arrow--right::before{content:\"\\e825\"}.react-multi-carousel-dot-list{position:absolute;bottom:0;display:flex;left:0;right:0;justify-content:center;margin:auto;padding:0;margin:0;list-style:none;text-align:center}.react-multi-carousel-dot button{display:inline-block;width:12px;height:12px;border-radius:50%;opacity:1;padding:5px 5px 5px 5px;box-shadow:none;transition:background .5s;border-width:2px;border-style:solid;border-color:grey;padding:0;margin:0;margin-right:6px;outline:0;cursor:pointer}.react-multi-carousel-dot button:hover:active{background:#080808}.react-multi-carousel-dot--active button{background:#080808}.react-multi-carousel-item{transform-style:preserve-3d;backface-visibility:hidden}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.react-multi-carousel-item{flex-shrink:0 !important}.react-multi-carousel-track{overflow:visible !important}}[dir='rtl'].react-multi-carousel-list{direction:rtl}.rtl.react-multiple-carousel__arrow--right{right:auto;left:calc(4% + 1px)}.rtl.react-multiple-carousel__arrow--right::before{content:\"\\e824\"}.rtl.react-multiple-carousel__arrow--left{left:auto;right:calc(4% + 1px)}.rtl.react-multiple-carousel__arrow--left::before{content:\"\\e825\"}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
